import { fetcher } from './fetcher';
import { ApiClient } from './_api';

export const apiClient = new ApiClient(fetcher(APP_CONFIG.apiBaseUrl));
